import styled from 'styled-components';

export const CorpSidePanel = styled.div`
  display: flex;
  padding: 3.2rem 3.2rem 4.6rem 3.2rem;
  margin-top: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex: 1 0 0;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.background.main};

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    flex-direction: column;
    align-items: center;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    width: 100%;
    justify-content: space-evenly;
    .side-panel-row {
      width: auto;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 28rem;
    flex-direction: column;
    justify-content: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    width: 100%;
    max-width: min-content;
    flex-direction: column;
    justify-content: center;
  }

  @media screen and (max-width: 42.5rem) {
    flex-direction: column;
    padding: 3.2rem 5.2rem 4.6rem 5.2rem;
    width: 35rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) and (min-width: 42.5rem) {
    gap: 5rem;
    width: 81%;
  }
`;

export const StyledCompanyIdLabel = styled.div`
  display: flex;
  height: 3.6rem;
  margin-bottom: 1.6rem;
  justify-content: center;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  align-self: center;
  border-radius: 3rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.background.lightest};
  background-color: ${({ theme }) => theme.colors.border.main};
  color: ${({ theme }) => theme.colors.text.main};

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    padding: 0.5rem 1rem;
    width: 33.5rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 0.7rem 1rem;
    margin-right: 0.5rem;
    width: 28rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 24rem;
    padding: 0.8rem 1.6rem;
  }
`;

export const StyledButtonColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    margin-top: 6rem;
    width: 34rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin: 8rem 0 6rem -2rem;
    width: 34rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 21rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    margin: 0;
    width: 25rem;
  }

  @media screen and (max-width: 42.5rem) {
    margin-top: 0;
    width: 32rem;
  }
`;

export const StyledContentColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 33rem;
  }
`;

export const StyledAvatar = styled.img`
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 3.2rem;
  object-fit: cover;
  margin: 0;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 4rem;
    height: 4rem;
  }
`;

export const StyledUsername = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.main};
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

export const StyledCompanyID = styled.p`
  font-family: Source Sans Pro;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.lighter};
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  }
`;

export const StyledCompanyNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.8rem;
  align-self: stretch;
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    gap: 0.4rem;
  }
`;

export const StyledAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
`;

export const StyledInstructorButton = styled.div`
  margin: 1rem 0 1rem;
  width: 32rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 24rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 21rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    width: 25rem;
  }
`;
